<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="新增品类"
      width="300px"
      :innerHeight="100"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <el-form :model="formData" :rules="rules" ref="ruleForm" size="mini" style="margin-top: 30px;">
        <el-form-item label="品类" prop="category">
          <el-input v-model.trim="formData.category"></el-input>
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import validator from 'validator';
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible'],
  data() {
    return {
      dialogVisible: false,
      formData: {},
      rules: {
        category: [
          { required: true, message: '不能为空', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.$refs['ruleForm'].validate(valid=>{
        if(valid) {
          this.submit();
        }else{

        }
      })
    },
    submit() {
      this.$q.product.addCategory({params: {
        category: this.formData.category
      }})
      .then(res=>{
        if(res.code == 200) {
          this.$message.success('新增成功');
          this.updateVal();
          this.$emit('complete')
        }else{
          this.$message.error(res.message);
        }
      })
    },
  }
}
</script>

<style>

</style>